<template>
    <div
        class="fixed bottom-8 left-8 max-w-md bg-white shadow-lg rounded-xl p-4 z-50 flex flex-col md:flex-row justify-between items-center">
        <p class="text-sm text-gray-800 mb-2 md:mb-0">
            Ce site utilise des cookies à des fins statistiques.
            <a href="/privacy-policy" class="underline">En savoir plus</a>.
        </p>
        <div class="flex gap-2">
            <button @click="$emit('rejected')"
                class="px-4 py-2 bg-gray-300 text-black rounded-lg hover:bg-gray-200 transition-colors">Refuser</button>
            <button @click="$emit('accepted')"
                class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark  transition-colors">Accepter</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CookieBanner'
};
</script>